module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-base-shadow-1.7b6d9934.png";